import { render } from "./UploadId.vue?vue&type=template&id=e6af3818&scoped=true"
import script from "./UploadId.vue?vue&type=script&lang=js"
export * from "./UploadId.vue?vue&type=script&lang=js"

import "./UploadId.vue?vue&type=style&index=0&id=e6af3818&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6af3818"]])

export default __exports__